'use strict';

exports.__esModule = true;
exports.withAsyncActions = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ramda = require('ramda');

var _reactRedux = require('react-redux');

var _asyncHelpers = require('./asyncHelpers');

var _ramdaAdditions = require('./utils/ramdaAdditions');

var _withAsyncHandlers = require('./withAsyncHandlers');

var _redux = require('redux');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var defaultOptions = {
  connectData: true,
  connectMeta: true,
  resetOnMount: false,
  resetOnUpdate: false,
  resetOnUnmount: false,
  dispatchOnMount: false,
  dispatchOnUpdate: false
};

var defaultShouldUpdate = function defaultShouldUpdate(props, nextProps, action) {
  if (!action.defaultPayload) {
    return false;
  }

  return !(0, _ramda.equals)(action.defaultPayload(props), action.defaultPayload(nextProps));
};

var renameDeprecatedKeys = (0, _ramdaAdditions.renameKeys)({
  autoFetch: 'dispatchOnMount',
  autoUpdate: 'dispatchOnUpdate',
  autoReset: 'resetOnUnmount'
});

var withAsyncActions = exports.withAsyncActions = function withAsyncActions(actionsConfig) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var mapStateToProps = arguments[2];
  var mapDispatchToProps = arguments[3];
  options = (0, _ramda.merge)(defaultOptions, renameDeprecatedKeys(options));

  var getOptions = function getOptions(action, props) {
    return (0, _ramda.merge)(options, renameDeprecatedKeys((0, _asyncHelpers.callWithProps)(action.options, props)));
  };

  return function (WrappedComponent) {
    var intervals = [];

    var hoc = function (_Component) {
      _inherits(hoc, _Component);

      function hoc() {
        _classCallCheck(this, hoc);

        return _possibleConstructorReturn(this, (hoc.__proto__ || Object.getPrototypeOf(hoc)).apply(this, arguments));
      }

      _createClass(hoc, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          var _this2 = this;

          var actions = (0, _asyncHelpers.getActions)(this.props, actionsConfig);
          (0, _ramda.forEachObjIndexed)(function (action, key) {
            (0, _ramda.when)((0, _ramda.prop)('dispatchOnMount'), function (options) {
              var getPayload = action.defaultPayload;

              _this2.props[key].dispatch(getPayload && getPayload(_this2.props));

              (0, _ramda.when)((0, _ramda.prop)('pollInterval'), function () {
                intervals.push(setInterval(function () {
                  _this2.props[key].dispatch(getPayload && getPayload(_this2.props));
                }, options.pollInterval));
              })(options);
            })(getOptions(action, _this2.props));
            (0, _ramda.when)((0, _ramda.prop)('resetOnMount'), function () {
              _this2.props[key].reset();
            })(getOptions(action, _this2.props));
          }, actions);
        }
      }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
          var _this3 = this;

          (0, _ramda.forEachObjIndexed)(function (action, key) {
            return (0, _ramda.when)((0, _ramda.prop)('dispatchOnUpdate'), function (options) {
              var shouldUpdate = action.shouldUpdate || defaultShouldUpdate;

              if (shouldUpdate(prevProps, _this3.props, action)) {
                (0, _ramda.when)((0, _ramda.prop)('resetOnUpdate'), prevProps[key].reset)(options);
                var getPayload = action.defaultPayload;

                _this3.props[key].dispatch(getPayload && getPayload(_this3.props));
              }
            })(getOptions(action, _this3.props));
          }, (0, _asyncHelpers.getActions)(this.props, actionsConfig));
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          var _this4 = this;

          (0, _ramda.forEachObjIndexed)(function (action, key) {
            return (0, _ramda.when)((0, _ramda.prop)('resetOnUnmount'), _this4.props[key].reset)(getOptions(action, _this4.props));
          }, (0, _asyncHelpers.getActions)(this.props, actionsConfig));
          (0, _ramda.forEach)(clearInterval, intervals);
        }
      }, {
        key: 'render',
        value: function render() {
          return _react2.default.createElement(WrappedComponent, this.props);
        }
      }]);

      return hoc;
    }(_react.Component);

    var stateToProps = function stateToProps(state, props) {
      var items = [];
      (0, _ramda.forEachObjIndexed)(function (action, actionName) {
        var actionOptions = (0, _ramda.merge)(options, action.options || {});

        if (actionOptions.connectData) {
          items.push([actionName + '_data', (0, _asyncHelpers.getActionData)(action, state, props)]);
        }

        if (actionOptions.connectMeta) {
          items.push([actionName + '_meta', (0, _asyncHelpers.getActionMeta)(action, state, props)]);
        }
      }, (0, _asyncHelpers.getActions)(props, actionsConfig));

      if (mapStateToProps) {
        return _extends({}, (0, _ramda.fromPairs)(items), mapStateToProps(state, props));
      } else {
        return (0, _ramda.fromPairs)(items);
      }
    };

    var dispatchToProps = function dispatchToProps(dispatch, props) {
      var actions = (0, _ramda.map)(function (action) {
        var params = (0, _asyncHelpers.callWithProps)(action.params, props);
        var assocParams = (0, _ramda.assoc)('params', params);

        var composeAction = function composeAction(action) {
          return (0, _ramda.compose)(dispatch, assocParams, action);
        };

        var dispatchAction = composeAction(action);
        var defaultPayload = action.defaultPayload && action.defaultPayload(props);
        return {
          refresh: function refresh(payload) {
            return dispatchAction(payload || defaultPayload);
          },
          dispatch: dispatchAction,
          request: composeAction(action.request),
          success: composeAction(action.success),
          error: composeAction(action.error),
          reset: composeAction(action.reset),
          load: composeAction(action.load)
        };
      }, (0, _asyncHelpers.getActions)(props, actionsConfig));
      var connectDispatch = (0, _ramda.is)(Object, mapDispatchToProps) ? (0, _redux.bindActionCreators)(mapDispatchToProps, dispatch) : mapDispatchToProps && mapDispatchToProps(dispatch, props);
      return (0, _ramda.merge)(actions, {
        __connect: connectDispatch
      });
    };

    var mergeProps = function mergeProps(stateProps, dispatchProps, ownProps) {
      var stateToProps = stateProps;
      return _extends({}, ownProps, (0, _ramda.mapObjIndexed)(function (action, key) {
        stateToProps = (0, _ramda.omit)([key + '_data', key + '_meta'], stateToProps);
        return _extends({
          type: action.type,
          data: stateProps[key + '_data'],
          meta: stateProps[key + '_meta']
        }, dispatchProps[key]);
      }, (0, _asyncHelpers.getActions)(ownProps, actionsConfig)), stateToProps, dispatchProps.__connect);
    };

    return (0, _reactRedux.connect)(stateToProps, dispatchToProps, mergeProps)((0, _withAsyncHandlers.withAsyncHandlers)(actionsConfig)(hoc));
  };
};